// 调证用户详情 - 简体中文
export default {
  header: {
    title: "调证用户",
    surveyReport: "调证报告",
  },
  note: {
    label: "备注：",
    empty: "暂无",
    edit: "编辑",
  },
  buttons: {
    downloadSurveyInfo: "下载调证信息",
  },
  walletBalance: {
    title: "钱包地址总余额",
    tooltip:
      "钱包地址总资产余额目前暂只统计（ETHEREUM、TRON、BSC、BTC、polygon等五条链地址的余额）\n\n根据本系统已收录的币种价值，按地址持有的所有主币和代币折算USDT的总余额",
    updatePrompt: "点击右边按钮更新余额",
    update: "更新",
    partialSuccess: "（部分地址余额更新成功）",
  },
  loading: {
    text: "拼命加载中",
  },
  statistics: {
    recharge: "充值(USDT）",
    withdrawal: "提现(USDT）",
    otcBuy: "otc买入(人民币)",
    otcSell: "otc卖出(人民币)",
    times: "次",
  },
  tabs: {
    userBehavior: "用户行为",
    otcTrading: "OTC交易",
    depositWithdrawal: "充提交易",
    walletBalance: "钱包余额",
    accountBalance: "账户余额",
    loginDevice: "登录/设备信息",
    receiveInfo: "收货信息",
    paymentMethod: "收款方式记录",
    otherInfo: "其他信息",
  },
};
